import PersonalizerApi from "@/services/personalizer_api";
import {
  RETRIEVE_CALLS, RETRIEVE_CALL_DETAILS, UPDATE_CALL_DETAIL, UPDATE_BULK_CALL_DETAILS, DELETE_CALL_DETAIL, DELETE_BULK_CALLS, GET_TASK_STATUS, SAVE_MASKED_TRANSCRIPTION, ADD_ALERT,
  GET_CHORUS_TASK_STATUS, RE_RUN_CHORUS_TASK, CREATE_TRANSCRIPTION
} from "@/store/_actiontypes";
import { SET_CALLS, SET_CALL_DETAIL } from "@/store/_mutationtypes";
import { FILTERCONDITION } from '@/global/_constants';
import { getCounselorPhones } from "@/helpers/SoftPhone_Information";
import ChorusApi from "@/services/chorus_api";

const state = {
  call_list: [],
  call_detail: {},
};
const actions = {
  [RETRIEVE_CALLS]({ commit, rootGetters }, { call_status, dest_phone_name, user_departments, search, start, size,search_filter,sort_field,sort_order="asce", toggleNaSwitch=false }) {
    return new Promise((resolve, reject) => {
      let data = {
        start: start || 0,
        size: size || 10,
        filters: [],
      };

      if (!toggleNaSwitch) {
        data.filters.push({
          key: "call_id",
          condition: FILTERCONDITION.exists,
        });
        data.filters.push({
          key: "call_id",
          values: [""],
          condition: FILTERCONDITION.must_not,
        });
      }
      if (call_status !== "all") {
        data.call_status = call_status;
      }

      if (dest_phone_name) {
        data.filters.push({
          key: "dest_phone_name",
          values: Array.isArray(dest_phone_name)?dest_phone_name: [dest_phone_name],
          condition: FILTERCONDITION.exact,
        });
      }

      if (search) {
        const withoutDash = search.replace(/-/g, "");
        if (/^\d+$/.test(withoutDash)) {
          data.search = withoutDash;
        } else data.search = search;
      }
      if (search_filter && Object.keys(search_filter).length > 0) {
        if (
          search_filter &&
          search_filter?.counselor_name &&
          search_filter?.counselor_name?.length > 0
        ) {
          const phones = getCounselorPhones(search_filter?.counselor_name);
          if (phones.length > 0) {
            search_filter.counselor_name = phones;
          }
        }
        if (
          search_filter &&
          search_filter?.caller &&
          search_filter?.caller?.length > 0
        ) {
          const flatCaller = search_filter?.caller.replace(/-/g, "").trim();
          search_filter.caller = flatCaller;
          if (
            flatCaller.length > 0 &&
            rootGetters["project/isAnalogProject"]
          ) {
            data.filters.push({
              key: "src_id",
              values: [flatCaller],
              condition: FILTERCONDITION.exact,
            });
            delete search_filter.caller;
          }
        }
        if (
          search_filter &&
          search_filter?.receiver &&
          search_filter?.receiver?.length > 0
        ) {
          const flatReceiver = search_filter?.receiver.replace(/-/g, "").trim();
          search_filter.receiver = flatReceiver;
          if (
            flatReceiver.length > 0 &&
            rootGetters["project/isAnalogProject"]
          ) {
            data.filters.push({
              key: "dest_id",
              values: [flatReceiver],
              condition: FILTERCONDITION.exact,
            });
            delete search_filter.receiver;
          }
        }
        if (search_filter && Object.keys(search_filter).length > 0) {
          data.search_filter = search_filter;
        }
      }
      if(sort_field?.length>0){
        data.sort_field=sort_field,
        data.sort_order=sort_order
      }

      if (user_departments && user_departments.length > 0 && user_departments[0].toLowerCase() !== "all") {
        data.filters.push({
          key: "dest_phone_name",
          values: user_departments,
          condition: FILTERCONDITION.match_phrase_prefix,
        });
      }

      if (data.filters.length === 0) {
        delete data.filters;
      }

      PersonalizerApi.post(`calls`, data).then(
        response => {
          const callList = response.data.detail.response;
          commit(SET_CALLS, callList);
          resolve(response.data.detail.response);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  [RETRIEVE_CALL_DETAILS]({ commit }, { session_id, call_id }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.get("call", { params: { session_id, call_id } }).then(
        response => {
          const callDetail = response.data.detail.response;
          commit(SET_CALL_DETAIL, callDetail);
          resolve(response.data.detail.response);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  [UPDATE_CALL_DETAIL]({ dispatch, commit }, { session_id, data }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`call/${session_id}?is_background=false`,
        data,
      ).then(
        response => {
          const callDetail = response.data.detail.response;
          commit(SET_CALL_DETAIL, callDetail);
          resolve(response.data.detail.response);
        },
        error => {
            dispatch(
              `alert/${ADD_ALERT}`,
              { message: "この呼び出しは見つからないか、アクセスできません。", color: "error" },
              { root: true }
            );
          reject(error);
        },
      );
    });
  },
  [UPDATE_BULK_CALL_DETAILS](_, update_items) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`calls/bulk_update`,
        update_items,
      ).then(
        response => {
          resolve(response.data.detail.response);
        },
        error => {
            console.error("Bulk update call details error:", error);
          reject(error);
        },
      ).catch((error) => {
        console.error("Bulk update call details caught error:", error);
        reject(error);
      });
    });
  },
  [SAVE_MASKED_TRANSCRIPTION]({ commit }, { session_id, param }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`call/${session_id}?is_background=false`,
        param,
      ).then(
        response => {
          const callDetail = response.data.detail.response;
          commit(SET_CALL_DETAIL, callDetail);
          resolve(response.data.detail.response);
        },
        error => {
          reject(error);
        },
      );
    });
  },
  [DELETE_CALL_DETAIL]({ dispatch }, { session_id }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`call/${session_id}`).then(
        response => {
          resolve(response.data.detail.response);
        },
        error => {
          dispatch(
            `alert/${ADD_ALERT}`,
            { message: "この呼び出しは見つからないか、アクセスできません。", color: "error" },
            { root: true }
          );
          reject(error);
        },
      );
    });
  },
  [DELETE_BULK_CALLS](_, { session_ids }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`calls`, { data: session_ids }).then(
        response => {
          resolve(response.data);
        },
        error => {
          console.error("Bulk delete calls error:", error);
          reject(error);
        },
      );
    });
  },
  [GET_TASK_STATUS](_, { task_id }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`tasks/${task_id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          console.error("Get task status error:", error);
          reject(error);
        },
      );
    });
  },
  [GET_CHORUS_TASK_STATUS](_, { chorus_task_id }) {
    return new Promise((resolve, reject) => {
      ChorusApi.get(`speeches/${chorus_task_id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },
  [RE_RUN_CHORUS_TASK](_, { task_id, audio_url, improve=null }) {
    const data = {
      ...(improve && { improve }),
      ...(audio_url && { audio_url }),
    }
    return new Promise((resolve, reject) => {
      ChorusApi.put(`/speeches/${task_id}/re-run`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },
  [CREATE_TRANSCRIPTION](_, { audio_url, task_type = "diarization", language = "ja", improve = null }) {
    const form = new FormData();
    form.append("audio_url", audio_url);
    form.append("task_type", task_type);
    form.append("language", language);
    if (improve) form.append("improve", improve);

    return new Promise((resolve, reject) => {
      ChorusApi.post(`/speeches`, form).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },
};

const mutations = {
  [SET_CALLS](state, data) {
    state.call_list = data;
  },

  [SET_CALL_DETAIL](state, data) {
    state.call_detail = data;
  },
};

export const call = {
  namespaced: true,
  state,
  actions,
  mutations,
};
